<div class="animate__animated animate__fadeIn app-version-{{ AppConfig.appVersion }}">
  <router-outlet></router-outlet>

  <div *hideProd>
    <span class="version" *ngIf="AppConfig.appVersion"> v{{ AppConfig.appVersion }} </span>
  </div>
</div>

<hm-spinner *ngIf="isLoading$ | async"></hm-spinner>
